<template>
  <div>
    <w-camera-button 
      :disabled="disabled"
      @click="handleCameraEvent"
    />
  </div>
</template>

<script>
import fileUploadMixin from '@/mixins/file-upload-mixin';

export default {
  name: 'WorkUploadButtons',
  props: {
    targetFieldPath: { type: String, required: true },
    taskPayload: { type: Object },
    cameraButtonClass: {type: String, default: ""}, 
    fileSubmitCallback: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  mixins: [    
    fileUploadMixin({
      fileSubmitCallback: (self) => self.fileSubmitCallback,
      targetFieldPath: (self) => self.targetFieldPath,
      taskPayload: (self) => self.taskPayload,
    }),
  ],
};
</script>